import { render, staticRenderFns } from "./AppBarThemeSwitcher.vue?vue&type=template&id=8be3046c"
import script from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports